export const environment = {
    production: true,
    deploy_environment: 'bb-jm',
    test_environment: undefined,
};
